import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import ExlyInput from "repoV2/features/Common/modules/Form/modules/ExlyInput/ExlyInput";
import commonStyles from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion.module.scss";
import checkoutCommonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";
import GSTDetailsFormGroupHeader from "./modules/GSTDetailsFormGroupHeader/GSTDetailsFormGroupHeader";
import {
    useGSTDetailsFormGroup,
    validators,
} from "./GSTDetailsFormGroup.utils";
import CheckoutAccordion from "../../../../../CheckoutAccordion/CheckoutAccordion";
import { checkout_form } from "../../../CheckoutForm/CheckoutForm.constants";
import GSTInfoComponent from "./modules/GSTInfoComponent/GSTInfoComponent";
import styles from "./GSTDetailsFormGroup.module.scss";

const {
    gst_details: { field_names, placeholders },
} = checkout_form;

const GSTDetailsFormGroup = () => {
    const {
        isExpanded,
        isGstRequired,
        handleGSTChecked,
        setGSTDetailsFormData,
        setGSTINDetailsFormData,
        eInvoiceEnabled,
    } = useGSTDetailsFormGroup();

    if (!isGstRequired) return null;

    return (
        <CheckoutAccordion
            defaultExpanded
            showExpandIcon={false}
            title={
                <GSTDetailsFormGroupHeader
                    isChecked={isExpanded}
                    handleCheckboxChange={handleGSTChecked}
                />
            }
            className={commonStyles.Wrapper}
            expanded={isExpanded}
            classes={{
                root: commonStyles.formGroupRoot,
                disabled: commonStyles.formGroupDisabled,
            }}
            headerClasses={{
                root: commonStyles.headerRoot,
                content: commonStyles.headerContent,
                disabled: commonStyles.formGroupDisabled,
                expanded: commonStyles.formGroupExpanded,
            }}
        >
            {isExpanded ? (
                <div className={commonStyles.BasicForm}>
                    <ExlyInput
                        name={field_names.company_name}
                        classes={{
                            helperText: checkoutCommonStyles.helperText,
                        }}
                        registerOptions={{
                            validate: validators[field_names.company_name],
                        }}
                        overrideInputProps={{
                            placeholder: placeholders.company_name,
                            autoComplete: "on",
                            fullWidth: true,
                            InputProps: {
                                className: checkoutCommonStyles.inputBaseText,
                            },
                            onBlur: () => {
                                setGSTDetailsFormData({
                                    fieldName: field_names.company_name,
                                });
                            },
                            className: checkoutCommonStyles.inputCustomStyles,
                        }}
                    />
                    <ExlyInput
                        name={field_names.registration_number}
                        classes={{
                            helperText: checkoutCommonStyles.helperText,
                        }}
                        registerOptions={{
                            validate:
                                validators[field_names.registration_number],
                        }}
                        overrideInputProps={{
                            placeholder: placeholders.registration_number,
                            autoComplete: "on",
                            fullWidth: true,
                            InputProps: {
                                className: classNames(
                                    checkoutCommonStyles.inputBaseText,
                                    styles.UppercaseText
                                ),
                            },
                            onBlur: () => {
                                setGSTINDetailsFormData();
                            },
                            className: checkoutCommonStyles.inputCustomStyles,
                        }}
                    />
                    {eInvoiceEnabled ? (
                        <>
                            <ExlyInput
                                name={field_names.company_address}
                                classes={{
                                    helperText: checkoutCommonStyles.helperText,
                                }}
                                registerOptions={{
                                    validate:
                                        validators[field_names.company_address],
                                }}
                                overrideInputProps={{
                                    placeholder: placeholders.company_address,
                                    autoComplete: "on",
                                    fullWidth: true,
                                    InputProps: {
                                        className:
                                            checkoutCommonStyles.inputBaseText,
                                    },
                                    onBlur: () => {
                                        setGSTDetailsFormData({
                                            fieldName:
                                                field_names.company_address,
                                        });
                                    },
                                    className:
                                        checkoutCommonStyles.inputCustomStyles,
                                }}
                            />
                            <ExlyInput
                                name={field_names.company_pincode}
                                classes={{
                                    helperText: checkoutCommonStyles.helperText,
                                }}
                                registerOptions={{
                                    validate:
                                        validators[field_names.company_pincode],
                                }}
                                overrideInputProps={{
                                    placeholder: placeholders.company_pincode,
                                    autoComplete: "on",
                                    fullWidth: true,
                                    InputProps: {
                                        className:
                                            checkoutCommonStyles.inputBaseText,
                                    },
                                    onBlur: () => {
                                        setGSTDetailsFormData({
                                            fieldName:
                                                field_names.company_pincode,
                                        });
                                    },
                                    className:
                                        checkoutCommonStyles.inputCustomStyles,
                                }}
                            />
                        </>
                    ) : null}
                    <div>
                        <GSTInfoComponent />
                    </div>
                </div>
            ) : (
                <></>
            )}
        </CheckoutAccordion>
    );
};

export default GSTDetailsFormGroup;
